<template>
  <li v-if="canViewVerticalNavMenuLink(item)" class="nav-item" :class="{
      'active': isActive,
      'disabled': item.disabled
    }">

    <b-link class="d-flex align-items-center item-menu" v-bind="linkProps">
      <font-awesome-icon :icon="['fas', item.icon ?? 'fa-circle']" />
      <span class="menu-title text-truncate">
        {{ item.title }}
      </span>
      
      <b-badge v-if="item.tag" pill :variant="item.tagVariant || 'primary'" class="badge-menu ms-50" >
        {{ resolverPromiseTag(item) }}
      </b-badge>

    </b-link>
  </li>
</template>

<script setup>
import { useUtils as useAclUtils } from '@composables/acl'

import useVerticalNavMenuLink from './useVerticalNavMenuLink';

const props = defineProps({
  item:{
    type:Object,
    required:true
  }
});
const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)

const { canViewVerticalNavMenuLink } = useAclUtils()
const resultTag = ref(0)

const resolverPromiseTag = (item) => {

  if(item.tag){
    item.tagValue().then((data) => {
      resultTag.value = data
    })
    return resultTag.value;
  }
  return 0;
  
}

</script>
<style lang="scss">
@use "@variables/variables" as *;




  .active-nav{
    
    // background: $danger !important;

    span{
      color:black;
      font-weight: 600;
    }
    
    svg{
      color:black;
    }

  }

</style>
